import { Notification } from '@lacedltd/laced-components'
import * as React from 'react'
import { useTranslation } from 'hooks'
import { withTranslations } from '../../../helpers'

export const PRICE_MATCHED_EVENT = 'sale-item:price-matched'

interface PriceMatchNotificationProps {
  initialCount: number
  ctaHref: string
}

const PriceMatchNotification: React.FC<PriceMatchNotificationProps> = ({
  initialCount,
  ctaHref
}) => {
  const { t } = useTranslation()
  const [count, setCount] = React.useState(initialCount)

  React.useEffect(() => {
    const handler = () => setCount((prev) => Math.max(0, prev - 1))

    window.addEventListener(PRICE_MATCHED_EVENT, handler)
    return () => window.removeEventListener(PRICE_MATCHED_EVENT, handler)
  }, [])

  const style = { marginBottom: '1rem' }

  if (count <= 0) {
    return (
      <Notification
        title={t('controllers.account.selling.all_items_are_lowest_heading')}
        text=""
        variant="success"
        style={style}
      />
    )
  }

  const cta =
    count >= 2
      ? {
          text: t('controllers.account.selling.match_remaining_prices', {
            matchable: count
          }),
          href: ctaHref,
          confirm: t('controllers.account.selling.confirm_new_price')
        }
      : undefined

  return (
    <Notification
      title={t('controllers.account.selling.first_queue')}
      text={t('controllers.account.selling.update_prices')}
      variant="info"
      cta={cta}
      style={style}
    />
  )
}

export default withTranslations(PriceMatchNotification)
